<template>
    <div>
        <div class="title">Potwierdzenie rejestracji</div>

        <div class="message has-icon is-info" v-if="isWorking" key="working">
            <div class="message-body has-text-weight-semibold">
            <span class="icon"><i class="far fa-sad-tear"></i></span>
                <p>Sprawdzam kod weryfikacyjny...</p>
            </div>
        </div>

        <transition name="fade" mode="out-in" appear>
            <div class="message has-icon is-success" v-if="isSuccess" key="success">
                <div class="message-body has-text-weight-semibold">
                <span class="icon"><i class="far fa-smile"></i></span>
                    <p class="subtitle">Dziękujemy za potwierdzenie rejestracji!</p>
                    <p>Po weryfikacji Twojego zgłoszenia wyślemy Twój numer uprawnień Instalatora na podany przy rejestracji adres e-mail.</p>
                </div>
            </div>
            <div class="message has-icon is-danger" v-if="isError" key="error">
                <div class="message-body has-text-weight-semibold">
                <span class="icon"><i class="far fa-sad-tear"></i></span>
                    <p>{{ errorMsg }}</p>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    data() {
        return {
            isSuccess: false,
            isError: false,
            isWorking: true,
            token: null,
            errorMsg: ''
        }
    },
    mounted() {
        this.token = this.$route.query.token;
        if(!this.token) {
            this.errorMsg = "Nieprawidłowy kod potwierdzający rejestrację.";
            this.isError = true;
            this.isWorking = false;
        }
        else {
            this.axios.get("checkActivationToken/" + this.token)
            .then(() => {
                this.isSuccess = true;
            })
            .catch((error) => {
                this.errorMsg = error.response.data.message ? error.response.data.message : 'Wystąpił błąd połączenia. Proszę spróbować jeszcze raz.';
                this.isError = true;
            })
            .finally(() => {
                this.isWorking = false;
            })
        }

    }
}
</script>

